export const config = {
  /** サーバーサイド（SSR）から API にアクセスする URL（Docker ネットワーク内部） */
  apiUrl: "https://api.local.b-faq.run:3000",
  /** クライアントサイド（ブラウザ）から API にアクセスする URL */
  publicApiUrl: "https://api.local.b-faq.run:3000",
  /** 公開サイトの URL（canonical URL 等に使用） */
  siteUrl: "https://faq.local.b-faq.run:3002",
  /** 管理画面の URL（preview バナーのリンク等に使用） */
  adminUrl: "https://admin.local.b-faq.run:3001",
} as const;
